import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import Input from '@src/components/inputs/Input'
import { css } from '@emotion/react'

const ChallengeForm = () => {
	const { getFieldProps } = useMyProductFormContext()

	return (
		<div>
			<Input
				label="챌린지 일수"
				type="number"
				{...getFieldProps('challenge.period', { min: 0 })}
				wrapperStyle={inputWrapperStyle}
				css={inputDayStyle}
			/>
			<Input
				label="환급조건 횟수"
				type="number"
				{...getFieldProps('challenge.minAuth', { min: 0 })}
				wrapperStyle={inputWrapperStyle}
				css={inputDayStyle}
			/>

			<Input
				label="어떤 걸 인증해야 하나요?"
				{...getFieldProps('challenge.title')}
				wrapperStyle={inputWrapperStyle}
				css={inputStyle}
				placeholder="ex) 제품 사용하는 모습 인증하기"
			/>
		</div>
	)
}

const inputWrapperStyle = css`
	margin-bottom: 1rem;
	flex-flow: column;
`

const inputDayStyle = css`
	box-sizing: border-box;
	width: 10rem;
`
const inputStyle = css`
	box-sizing: border-box;
	width: 25rem;
`
export default ChallengeForm
